/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type {
	LayoutState,
	BannerState,
	LeftSidebarState,
	RightSidebarState,
	BottomRightPortalState,
	PreviewPanelState,
} from '../../../common/types.tsx';
import { showBanner, dismissCurrentBanner } from './banner/index.tsx';
import {
	registerBottomRightCornerContainer,
	insertBottomRightCornerPortal,
	removeBottomRightCornerPortal,
} from './bottom-right-corner/index.tsx';
import { setIsChromeless } from './chromeless/index.tsx';
import { setIsFullscreen } from './fullscreen/index.tsx';
import { setLeftSidebarState } from './left-sidebar/index.tsx';
import {
	setRightSidebarState,
	openRightSidebar,
	closeRightSidebar,
	closeAllRightSidebar,
	closeCurrentRightSidebar,
	minimiseRightSidebar,
} from './right-sidebar/index.tsx';
import { setPreviewPanelState } from './preview-panel/index.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { RightSidebarControllerType } from './right-sidebar';

export const actions: {
	// global
	readonly setIsChromeless: (isChromeless: boolean) => Action<LayoutState>;
	readonly setIsFullscreen: (isFullscreen: boolean) => Action<LayoutState>;
	// banner
	readonly showBanner: (newState: BannerState) => Action<LayoutState>;
	readonly dismissCurrentBanner: () => Action<LayoutState>;
	// left-sidebar
	readonly setLeftSidebarState: (newState: Partial<LeftSidebarState>) => Action<LayoutState>;
	// right-sidebar
	readonly setRightSidebarState: (newState: RightSidebarState) => Action<LayoutState>;
	readonly openRightSidebar: (
		panelId: string,
		width: number,
		isMinimised?: boolean,
		toTop?: boolean,
	) => Action<LayoutState>;
	readonly closeRightSidebar: (panelId: string) => Action<LayoutState>;
	readonly closeAllRightSidebar: () => Action<LayoutState>;
	readonly closeCurrentRightSidebar: () => Action<LayoutState>;
	readonly minimiseRightSidebar: (panelId: string) => Action<LayoutState>;
	// bottom-right-corner
	readonly registerBottomRightCornerContainer: (
		ref: HTMLElement | null | undefined,
	) => Action<LayoutState>;
	readonly insertBottomRightCornerPortal: (
		item: BottomRightPortalState,
	) => Action<LayoutState, void, number>;
	readonly removeBottomRightCornerPortal: (id: string) => Action<LayoutState>;
	// preview panel
	readonly setPreviewPanelState: (newState: Partial<PreviewPanelState>) => Action<LayoutState>;
} = {
	// global
	setIsChromeless,
	setIsFullscreen,

	// banner
	showBanner,
	dismissCurrentBanner,

	// left-sidebar
	setLeftSidebarState,

	// right-sidebar
	setRightSidebarState,
	openRightSidebar,
	closeRightSidebar,
	closeAllRightSidebar,
	closeCurrentRightSidebar,
	minimiseRightSidebar,

	// bottom-right-corner
	registerBottomRightCornerContainer,
	insertBottomRightCornerPortal,
	removeBottomRightCornerPortal,

	// preview panel
	setPreviewPanelState,
} as const;

export type LayoutActions = typeof actions;
